module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("auMDU"))).then(() => parcelRequire('lzblW'));